import {
  BookkeepersCompanyIncidenceMessageStatFragment,
  BookkeepersCompanyIncidenceStatFragment,
  BookkeepersCompanyIncidenceStatsDocument,
} from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

import { useIncidenceFilterContext } from 'modules/bookkeepers/lib/IncidenceFilterContext'
import { useBookkeeperView } from 'modules/bookkeepers/lib/bookkeeperViewContext'
import { MESSAGE_SENDER } from 'modules/bookkeepers/lib/constants'

interface IncidenceStats {
  incidenceStats: BookkeepersCompanyIncidenceStatFragment[]
  incidenceMessageStats: BookkeepersCompanyIncidenceMessageStatFragment[]
}

const useGetIncidenceStats = (): IncidenceStats => {
  const { filterDate, selectedCompany } = useIncidenceFilterContext()
  const isBookkeeperView = useBookkeeperView()
  const bookkeeperContext = {
    isBookkeeperView,
  }
  const messageFrom = isBookkeeperView ? MESSAGE_SENDER.admin : MESSAGE_SENDER.bookkeeper

  const { data: incidenceStatsData } = useQuery(BookkeepersCompanyIncidenceStatsDocument, {
    context: bookkeeperContext,
    variables: {
      companyId: selectedCompany?.id,
      endsOn: filterDate.lastDate,
      startsOn: filterDate.firstDate,
      messageFrom: messageFrom || '',
    },
    fetchPolicy: 'network-only',
  })
  const incidenceStats =
    incidenceStatsData?.bookkeepersManagement.incidenceStatsConnection.nodes ?? []
  const incidenceMessageStats =
    incidenceStatsData?.bookkeepersManagement.incidenceMessageStatsConnection.nodes ?? []

  return { incidenceStats, incidenceMessageStats }
}

export default useGetIncidenceStats
